export const GET_CONTACTS_QUERY_KEY = ['contacts'] as const;
export const ADD_NEW_CONTACT_QUERY_KEY = ['addNewContact'] as const;
export const EDIT_CONTACT_QUERY_KEY = ['editContact'] as const;
